import { render } from "./InstructorsList.vue?vue&type=template&id=48771b82&scoped=true"
import script from "./InstructorsList.vue?vue&type=script&lang=js"
export * from "./InstructorsList.vue?vue&type=script&lang=js"

import "./InstructorsList.vue?vue&type=style&index=0&id=48771b82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48771b82"]])

export default __exports__